import React, { Component } from 'react';
import Notification from '../Notification';
import styled, { keyframes } from 'styled-components';
import { withRouter } from 'react-router-dom';
import * as variables from '../../styles/variables';

const opacity = keyframes`
  from {
    background: rgba(0,0,0,0.0);
  }

  to {
    background: rgba(0,0,0,0.5);
  }
`;

const popIn = keyframes`
  from {
    // transform: scale(0.00001);
    transform: translateY(-100%);
  }

  to {
    // transform: scale(1);
    transform: translateY(0);
  }
`;

const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  background: rgba(0,0,0,0.5);
  animation: ${opacity} .3s ease-out;
  animation-fill-mode: forward;
  font-family: ${variables.fonts.body};
  -webkit-overflow-scrolling: touch;
`

const Box = styled.div`
  max-width: 600px;
  width: 100%;
  background: white;
  margin-top: 100px;
  margin-bottom: 100px;
  padding: 30px 20px;
  border-radius: 10px;
  box-shadow: 2px 2px 30px rgba(0,0,0,0.4);
  animation: ${popIn} .2s ease-out;
  animation-fill-mode: forward;
`

class Modal extends Component {
  constructor(props) {
    super(props)
    this.handleKeyboard = this.handleKeyboard.bind(this)
  }

  componentDidMount() {
    window.addEventListener('keydown', this.handleKeyboard)
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.handleKeyboard)
  }

  handleKeyboard(e) {
    if (e.key === 'Escape') {
      this.props.history.go(-1)
    }
  }

  render() {
    return (
      <Backdrop>
        <Box>
          <Notification type={this.props.alertType} message={this.props.alertMessage} />
          {this.props.children}
        </Box>
      </Backdrop>
    )
  }
}

export default withRouter(Modal)